/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import AppointmentOverlay from './AppointmentOverlay/index'
import Content from './Content/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import EventUpdates from './EventUpdates/index'
import React from 'react'
import SyncSectionParams from './SyncSectionParams/index'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Calendar/New"
  
}) {
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<SyncSectionParams
  viewPath={`${viewPath}/SyncSectionParams`}
/>
<EventUpdates
  viewPath={`${viewPath}/EventUpdates`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
<AppointmentOverlay
  viewPath={`${viewPath}/AppointmentOverlay`}
/>
{children}
</React.Fragment>)
}